{
  "title": "Cuentas para pago de tarifas",
  "subTitle": "Para cada cuenta, puede seleccionar una cuenta diferente sin registrar desde la que desea retirar las tarifas.",
  "noAccountsInHousehold": "No hay cuentas en este hogar. Primero cree o asocie una cuenta.",
  "registeredAccounts": "Cuentas registradas",
  "set": "Configurar cuentas de pago",
  "feePaymentAccountsUpdated": "Se actualizaron las cuentas para pago de tarifas"
}
